/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */

import {
  console_if_debug,
  } from './blackmostros.method.js';


/*
function _private() {
  var _displayed = false,
    $mobile,
    $menu,
    $menuWrapper,
    $topmenuwrap,
    _showinres,
    Joomla,
    Showopenmenu,
    Openmenu,
    Closemenu,
    mpublic = {
      // ~ init: _init
      };

  function _init(){
    console.log('hola');
    }
  mpublic.init=_init

  return mpublic;
}

Mobile = {

  _main: function(){
    var data = new _private();
    return {}
    }(),

  say_hi: function(){
    this._main.init();
    },

  };
*/

var BlackMostrosMobileButton = (function(
  $
  // ~ _q  // to remove
  ){
  /*
   * Mobile button to show or hide menu
   *
   */
  var _displayed = false,
    $mobile,
    $menu,
    $menuWrapper,
    $topmenuwrap,
    _showinres,
    Joomla,
    Showopenmenu,
    Openmenu,
    Closemenu,
    _hide_class='hidden',
    // ~ Showopenmenu = Joomla.JText._('TPL_BLACKMOSTROS1_SHOWOPENMENU'),
    // ~ Openmenu = Joomla.JText._('TPL_BLACKMOSTROS1_OPENMENU'),
    // ~ Closemenu = Joomla.JText._('TPL_BLACKMOSTROS1_CLOSEMENU'),
    mpublic = {};

  function _hide_menu(){
    /*
     * hide menu only if in mobile screens
     *
     */
    // ~ console.log('hide menu');
    $menuWrapper.hide();
    // ~ $menuWrapper.classList.add(_hide_class);
    /*
    var state = $menuWrapper.css('display');
    if (state != 'none') {
      $menuWrapper.slideToggle();
    }
    */

  }

  function _show_menu(){
    // ~ console.log('show menu');
    $menuWrapper.show();
    // ~ $menuWrapper.classList.remove(_hide_class);
    /*
    var state = $menuWrapper.css('display');
    if (state === 'none') {
      $menuWrapper.slideToggle();
    }
    */
  }

  function _hide_or_show_menu(){

    /*
    function _old_method() {
      //~ var Closemenu = Joomla.JText._('TPL_BLACKMOSTROS1_CLOSEMENU');
      var state = $menuWrapper.css('display');

      $menuWrapper.slideToggle();

      if (state === 'none') {
        if (Showopenmenu) {
          $('#menuopener')
            .html(Closemenu);
        }
        $('#menuwrapper ul.menu').css({'display': 'inherit'});
        $('#menuwrapper')
          .attr('aria-expanded', 'true')
          .attr('aria-hidden','false');
            //   and menu ul
      } else {
        if (Showopenmenu) {
          $('#menuopener')
            .html(Openmenu);
        }
        $('#menuwrapper')
          .attr('aria-expanded', 'false')
          .attr('aria-hidden', 'true');
      }
    }
    */

    function _new_method() {
      if ($menuWrapper.classList.contains(_hide_class)) {
        $menuWrapper.show();
      } else {
        $menuWrapper.hide();
      }
    }
    _new_method();
  }

  function _set_joomla_texts() {
    Showopenmenu = Joomla.JText._('TPL_BLACKMOSTROS1_SHOWOPENMENU');
    Openmenu = Joomla.JText._('TPL_BLACKMOSTROS1_OPENMENU');
    Closemenu = Joomla.JText._('TPL_BLACKMOSTROS1_CLOSEMENU');
  }

  function _createElements(menu, menuWrapper) {
    $menu = menu;
    $menuWrapper = menuWrapper;

    /*
    function _old_method () {
      // ~ $menu = menu;
      // ~ $menuWrapper = menuWrapper;

      //~ Closemenu = Joomla.JText._('TPL_BLACKMOSTROS1_CLOSEMENU');

      if (Showopenmenu) {
        var spanopenmenu = '<span>' + Openmenu + '</span>';
      } else {
        var spanopenmenu = '<span class="glyphicon glyphicon-menu-hamburger" aria-hidden="true"></span>';
      }

      // create the menu opener and assign events
      $mobile = $('<div>', {id: 'mobile_select'})
        .html(
          '<h2><a href="#" id="menuopener" onclick="return false;" aria-label="Show/Hide Pronia menu.">'+spanopenmenu+'</a></h2>'
        ).show();

      $mobile.on('click', _hide_or_show_menu);

      // add the menu to the dom
      $menu.wrap($menuWrapper);

      // add the menuopener to the dom and hide it
      $('#head').find('#menuwrapper').first().before($mobile.show());
      // ~ $('#back').find('#menuwrapper').first().before($mobile.show());
      $menuWrapper = $('#menuwrapper');
      $mobile = $('#mobile_select');
    }
    */

    function _new_method() {
      // ~ $menuWrapper = document.getElementById('menuwrapper');
      $mobile = $.getElementById('mobile_select');
      function _show() {
        $mobile.classList.remove(_hide_class);
        // ~ $mobile.style.visible = 'visible';
        }
      $mobile.show = _show;
      function _hide () {
        $mobile.classList.add(_hide_class);
        // ~ $mobile.style.visible = 'hidden';
        }
      $mobile.hide = _hide;
      $mobile.addEventListener(
        'click', _hide_or_show_menu
        );

      /*
       * display menu wrapper
       * when <noscript>, we need add #id display inherit
       * in html code
       */
      $menuWrapper.style.display = 'inherit';
      // ~ console.log($mobile, $menu, $menuWrapper);
    }

    _new_method();
  }

  function show() {
    $menuWrapper.hide();
    $mobile.show();
    _displayed = true;
  }

  function hide() {
    $menuWrapper.show();
    $mobile.hide();
    _displayed = false;
  }

  function _hide_or_show(width){
    if (width < _showinres && !_displayed) {
      show();
    }
    else if (width >= _showinres && !_displayed) {
      hide();
    }

    if (width >= _showinres) {
      if (_displayed) {
        hide();
      }
    } else {
      if (!_displayed) {
        show();
      }
    }
  }

  function _init($menu, $menuWrapper, showinres) {
    _showinres = showinres;
    // ~ when_external_loaded(Joomla);

    // create the elements once
    // ~ console.log($menu, $menuWrapper)
    _createElements($menu, $menuWrapper);
    console_if_debug('Mobile menu ready...');
    // ~ console.log('Mobile menu ready...');
  }

  mpublic.hide_menu = _hide_menu;
  mpublic.show_menu = _show_menu;
  mpublic.hide_or_show_menu = _hide_or_show_menu;
  mpublic.hide_or_show = _hide_or_show;
  mpublic.init = _init;

  return mpublic;

});

export {
  BlackMostrosMobileButton,
  }
